import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_play",
  "use": "svg_play-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_play\"><path d=\"M9 .667a8.333 8.333 0 1 0 0 16.666A8.333 8.333 0 0 0 9 .667Zm0 15.63A7.297 7.297 0 1 1 16.296 9 7.306 7.306 0 0 1 9 16.296ZM6.407 4.49v9.018L14.222 9 6.407 4.49Zm1.038 1.852 4.694 2.703-4.704 2.658.01-5.361Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol